module.exports = __webpack_public_path__ + "assets/images/filter-outline.901d8565dfed6192b811eb4df0470874.svg";